import { useState } from 'react';

export function useToggle(initialState: boolean): [boolean, () => void] {
  const [toggled, setToggled] = useState(initialState);

  return [toggled, () => setToggled((state) => !state)];
}
